<script setup>
import { ref, defineExpose, onMounted } from 'vue'
// const props = defineProps({
//   show: {
//     type: Boolean,
//     default: true
//   }
// })
// onMounted(() => {
//   console.log(show)
//   show.value = props.show
// })
const show = ref(false)
const open = () => {
  show.value = true
}
const close = () => {
  show.value = false
}
defineExpose({
  open
})
</script>
<template>
  <van-popup v-model:show="show" round closeable position="bottom">
    <div class="bg-[#fff] py-36 px-30">
      <div class="flex items-center">
        <img src="/src/assets/icon/public/notice.png" class="w-58 h-58" alt="" />
        <div class="text-[32px] text-[#000] font-800 font-roboto ml-16px">通知</div>
      </div>
      <div class="h-2 bg-[#000]/10 mt-24px"></div>
      <div class="mt-24px">
        <p class="text-[30px] text-[#000] font-600 font-roboto line-height-42px">
          Ecosystem asset release engine + decentralized participation platform +
          <span class="text-[#000B85]">disruptive DeFi 4.0</span>
        </p>
        <p class="text-[30px] text-[#000] font-400 font-roboto line-height-42px">
          application protocolEcosystem asset release engine + decentralized participation platform
          + disruptive DeFi 4.0 application protocolsset release engine + decentralized
          participation
        </p>
      </div>
      <div
        class="_btn h-84 text-[30px] text-[#fff] font-source font-700 line-height-84px text-center mt-30px van-haptics-feedback"
        @click="close"
      >
        知道了
      </div>
    </div>
  </van-popup>
</template>
<style lang="scss" scoped>
.container {
  padding: 20px;
}
._btn {
  border-radius: 20px;
  background: linear-gradient(91deg, #02070b -9.72%, #000b85 54.24%, #326eff 102.08%);

  /* 11 */
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15);
}
</style>
